import { render, staticRenderFns } from "./VoucherDetail.vue?vue&type=template&id=5556bf85&scoped=true&"
import script from "./VoucherDetail.vue?vue&type=script&lang=js&"
export * from "./VoucherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5556bf85",
  null
  
)

export default component.exports